import JTOObject from '../utils/jto/JTOObject';
import JTOSimple from '../utils/jto/JTOSimple';
import JTOProperty from '../utils/jto/JTOProperty';
import JTORelProperty from '../utils/jto/JTORelProperty';
import JTOList from '../utils/jto/JTOList';
import JTOElement from '../utils/jto/JTOElement';
import FileSuper from './FileSuper';

export default class FileMessage extends FileSuper {
    public static _TYPE: string = 'FileMessage';

    constructor(parent?: JTOElement | null) {
        super(FileMessage._TYPE, parent);
    }
}
